import * as ko from "knockout";
import entityBase from "entityBase";
import { CustomObservables } from "app/custom-observables";

export class solution_text extends entityBase {
  solution_id: KnockoutObservable<string>;
  text_line_code: KnockoutObservable<string>;
  text_id: KnockoutObservable<string>;
  text_sequence: KnockoutObservable<string>;
  text: KnockoutObservable<string>;
  text_rtf: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;

  isTitleCollapsed: KnockoutObservable<boolean>;

  constructor(item?: any) {
    super();
    this.solution_id = ko.observable(item?.solution_id);
    this.text_line_code = ko.observable(item?.text_line_code);
    this.text_id = ko.observable(item?.text_id);
    this.text_sequence = ko.observable(item?.text_sequence);
    this.text = ko.observable(item?.text);
    this.text_rtf = ko.observable(item?.text_rtf);
    this.created_by = ko.observable(item?.created_by);
    this.created_dttm = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);

    this.isTitleCollapsed = ko.observable(true);
  }
}
